export const SUPPLIERS_CONSTRAINTS = {
  SET_SUPPLIERS_LIST: "SET_SUPPLIERS_LIST",
  SET_SUPPLIER_DETAILS: "SET_SUPPLIER_DETAILS",
  SET_SUPPLIERS_ITEMS: "SET_SUPPLIERS_ITEMS",
  SET_SUPPLIERS_ITEM_DETAILS: "SET_SUPPLIERS_ITEM_DETAILS",
  SET_SORTING_LIST: "SET_SORTING_LIST",
  SET_LIST_FILTER: "SET_LIST_FILTER",
  SET_SECTIONS_LIST: "SET_SECTIONS_LIST",
};
